// footer.accordion.js
document.addEventListener('DOMContentLoaded', function () {
  var mq = window.matchMedia('(min-width: 750px)');

  // Pas de staat toe op alle accordions (of binnen een specifieke container)
  function applyState(root) {
    var scope = root || document;
    var accordions = scope.querySelectorAll('details.FooterAccordion');
    var isDesktop = mq.matches;

    accordions.forEach(function (el) {
      if (isDesktop) {
        // Desktop: forceer open en markeer dat dit door script is gedaan
        if (!el.hasAttribute('open')) el.setAttribute('open', '');
        el.dataset.lockedOpen = '1';
      } else {
        // Mobiel: haal de geforceerde open-staat weg, laat gebruikerskeuze intact
        if (el.dataset.lockedOpen === '1') {
          el.removeAttribute('open');
          delete el.dataset.lockedOpen;
        }
      }
    });
  }

  // Initieel toepassen
  applyState();

  // Reageer op breakpoint wissel
  if (mq.addEventListener) {
    mq.addEventListener('change', function () { applyState(); });
  } else {
    // Fallback voor oudere Safari
    mq.addListener(function () { applyState(); });
  }

  // Theme editor: wanneer een sectie opnieuw geladen/selecteerd wordt
  document.addEventListener('shopify:section:load', function (e) { applyState(e.target); });
  document.addEventListener('shopify:section:select', function (e) { applyState(e.target); });
});